import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import _ from 'lodash'
//import TestData from './data'
import UserFilter from '../UserFilter'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import DataFilter from '../DataFilter'
import TableFilter from '../TableFilter'
import CommesseComboFilter from '../CommesseComboFilter'
import PrintButton from '../PrintButton'
import ElaboraButton from '../ElaboraButton'
import LocalDate from '../LocalDate'
import {minutesToHuman} from '../../Helpers'
import FileSaver from 'file-saver';
import PdfButton from '../PdfButton'
import AttivitaPerGiorno from '../../pdf/AttivitaPerGiorno'
import Moment from 'moment';
import PropTypes from 'prop-types';
class ReportAttivitaGiornaliero extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: undefined,
            filterInfo: {
                idUtente: client.getCurrentUserId(),
                idCommessa: 0,
                tipo: 'i',
            },
            _loading: false,
            error: null,
            column: null,
            direction: null,
        };
        this.onChangeUserFilter = this.onChangeUserFilter.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeCommessaFilter = this.onChangeCommessaFilter.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
        this.loadData = this.loadData.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
    }

    getFilterDescription(){
        let msg = '';
        msg += 'Periodo dal ' + Moment(this.state.filterInfo.dataStart).format('DD/MM/YYYY') +
            ' al ' + Moment(this.state.filterInfo.dataEnd).format('DD/MM/YYYY');
        msg += ' Utenti: ' + this.state.filterInfo.nomeUtente;
        msg += ' Commesse: ' + this.state.filterInfo.nomeCommessa;
        return msg;
    }

    pdfExport(){
        let ce = new AttivitaPerGiorno();
        ce.setTitle("Report Giornaliero Attività");
        ce.setFileName("report-giornaliero-attivita.pdf");
        ce.setOrientationPortrait();
        ce.setFilterDescription(this.getFilterDescription());
        ce.createPdf(this.state.items);
    }

    componentWillUnmount() {
    }

    componentDidMount() {
    }
    onChangeFilter(data) {
        let filter = this.state.filterInfo;
        filter.keyword = data.keyword;
        this.setState({filterInfo: filter, items: undefined})
    }

    onChangeUserFilter(idutente, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idUtente = idutente;
        filterInfo.nomeUtente = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeCommessaFilter(idcommessa, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idCommessa = idcommessa;
        filterInfo.nomeCommessa = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, items:undefined})
    }

    handleSort = clickedColumn => () => {
        const { column, items, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                items: _.sortBy(items, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            items: items.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    loadData() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportAttivitaGiornaliero(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa,
            filterInfo.keyword
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onExportClick(tipo){
        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.exportReportAttivitaGiornaliero(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa, tipo, filterInfo.keyword
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'report_attivita_giornaliero.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {
        let i = 1;
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg}  onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let durataPesataTot = 0;
        let tableData = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;
        if (this.state.items !== undefined){
            if (this.state.items.length > 0){
                stampaButton = <PrintButton/>
                exportExcelButton = (<a href="#" onClick={(ev) => (this.onExportClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Esporta
                    </div>
                </a>)
                exportPdfButton = (<PdfButton onClick={(ev) => (this.pdfExport())} />)
                tableData = (
                    <div className="ui segment">
                        <h4>Report Giornaliero Attività</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell sorted={this.state.column === 'giorno' ? this.state.direction : null} >
                                        giorno
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'idUtente.nome' ? this.state.direction:null} >
                                        Utente
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'durataPesata' ? this.state.direction:null} >
                                        Durata Totale (h:m:s)
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.items.map((item) => {

                                        durataPesataTot += item.durataPesata;
                                        return <Table.Row key={i++}>
                                            <Table.Cell><LocalDate data={item.giorno} /></Table.Cell>
                                            <Table.Cell>{item.utente.username}</Table.Cell>
                                            <Table.Cell  textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                        </Table.Row>
                                    })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="2">Totali</Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center'><b>{minutesToHuman(durataPesataTot)}</b></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
            else {
                tableData = (
                    <div className="ui segment">
                        <h4>Tempo Speso per Giorno e per Commessa</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Body>
                                <Table.Row key={1}>
                                    <Table.Cell><h4>Nessun dato disponibile</h4></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
        }


        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="clock icon"/> Report Giornaliero Attività
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui one column stackable grid">
                <div className="ui two column grid">
                <div className="ten wide column">
                    <DataFilter
                        showOption={'specs'}
                        tipo={this.state.filterInfo.tipo}
                        dataDal={this.state.filterInfo.dataStart}
                        dataAl={this.state.filterInfo.dataEnd}
                        fireOnChangeOnStart={true}
                        onChange={this.onChangeData}
                    />
                </div>
                <div  className="six wide column">
                    <TableFilter
                        showPopup={true}
                        changeEventOnKeyPress={true}
                        value={this.state.filterInfo.keyword}
                        placeholder="Filtra attività per nota..."
                        onChangeFilter={this.onChangeFilter} />
                </div>
                </div>
                <div className="column">
                    <div className="ui two column grid">
                        <div className="column">
                            <div className="ui two column grid">
                                <div className="column">
                            <UserFilter
                                idUtente={this.state.filterInfo.idUtente}
                                abilitato={client.isCurrentUserAdmin()}
                                itemTutti={false}
                                onChange={this.onChangeUserFilter}
                                dataDal={this.state.filterInfo.dataStart}
                                dataAl={this.state.filterInfo.dataEnd}
                            />
                                </div>
                                <div className="column">
                            <CommesseComboFilter
                                idCommessa={this.state.filterInfo.idCommessa}
                                abilitato={true}
                                onChange={this.onChangeCommessaFilter}
                            />
                                </div>
                        </div>
                        </div>
                        <div className="column">
                            <ElaboraButton text="Elabora" onClick={this.loadData} /> {stampaButton} {exportExcelButton} {exportPdfButton}
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {tableData}
            {loader}
        </div>)
    }
}

ReportAttivitaGiornaliero.contextTypes = {
    router: PropTypes.object
}

export default ReportAttivitaGiornaliero;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportAttivitaGiornaliero.js
 **/